import Paper from "@material-ui/core/Paper";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { animated, Spring } from "react-spring/renderprops";
import Header from "../../components/Header/Header";
import { getCardPositionStyle } from "./cardPositionStyles";
import { LayoutBackgroundPlaceholder } from "./LayoutBackground";
import styles from "./styles.module.css";

export const Layout = React.memo(({ children, verticalPosition, horizontalPosition, fullHeight }) => {
  const isRestoringSession = useSelector((state)=>state?.authorization?.isRestoringSession);
  const [ immediate, setImmediate ] = React.useState(true);
    React.useEffect(() => {
      setImmediate(true);
      setTimeout(() => {
        setImmediate(false);
      }, 0);
    }, [ setImmediate,isRestoringSession ]);

    return (
      <div className={styles.container}>
        <Header />
        <div className={styles.content}>
          <div className={styles.contentContainer}>
            <Spring immediate={immediate} native to={getCardPositionStyle(verticalPosition, horizontalPosition, fullHeight)}>
              {style => (
                <animated.div style={style} className={classNames(styles.card)}>
                  <Paper elevation={12} className={styles.cardPaper}>
                    <div className={styles.children}>
                      {children}
                    </div>
                  </Paper>
                </animated.div>
              )}
            </Spring>
          </div>
          <LayoutBackgroundPlaceholder className={styles.background} />
        </div>
      </div>
    );
  },
);

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  verticalPosition: PropTypes.oneOf([ "top", "middle", "bottom" ]),
  horizontalPosition: PropTypes.oneOf([ "left", "center", "right" ]),
  fullHeight: PropTypes.bool,
};

Layout.defaultProps = {
  children: undefined,
  verticalPosition: "middle",
  horizontalPosition: "center",
  fullHeight: false,
};
